import {
  Anchor2,
  Arrow2,
  Close,
  Content2,
  Portal,
  Root2,
  Trigger
} from "../../../chunk-X4KWBYW4.mjs";
import "../../../chunk-VQI4KMJ3.mjs";
import "../../../chunk-MTQX4T3Q.mjs";
import "../../../chunk-XFG5THGD.mjs";
import "../../../chunk-YNII5Y6F.mjs";
import "../../../chunk-RRWBFD4V.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-4U6MH43A.mjs";
import "../../../chunk-OPCIACWD.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-7TMHQ6XO.mjs";
import "../../../chunk-BQ72SK4G.mjs";
import "../../../chunk-FBWCVJGC.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Popover/Popover.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var cx = (...parts) => parts.filter(Boolean).join(" ");
function Popover(props) {
  return /* @__PURE__ */ jsx(Root2, { ...props });
}
Popover.displayName = "Popover";
function PopoverTrigger({ ref, ...props }) {
  return /* @__PURE__ */ jsx(Trigger, { ref, ...props });
}
PopoverTrigger.displayName = "PopoverTrigger";
function PopoverAnchor(props) {
  return /* @__PURE__ */ jsx(Anchor2, { ...props });
}
PopoverAnchor.displayName = "PopoverAnchor";
function PopoverClose({ ref, ...props }) {
  return /* @__PURE__ */ jsx(Close, { ref, ...props });
}
PopoverClose.displayName = "PopoverClose";
var TIP_WIDTH = 24;
function useTipOffset(content) {
  React.useLayoutEffect(() => {
    const probe = content?.querySelector(".buyscout-popover__tip-probe");
    const probeWrapper = probe?.parentElement;
    if (!content || !probe || !probeWrapper) return;
    const sync = () => {
      const probeBox = probe.getBoundingClientRect();
      const x = probeBox.left + probeBox.width / 2 - content.getBoundingClientRect().left;
      content.style.setProperty("--buyscout-popover-tip-x", `${x}px`);
      content.toggleAttribute("data-tip-hidden", probeWrapper.style.visibility === "hidden");
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(probeWrapper, { attributes: true, attributeFilter: ["style"] });
    return () => observer.disconnect();
  }, [content]);
}
function PopoverContent({
  ref,
  container,
  className,
  align = "start",
  sideOffset = 8,
  collisionPadding = 8,
  tip = false,
  children,
  ...props
}) {
  const [content, setContent] = React.useState(null);
  const attach = React.useCallback((node) => {
    if (ref) ref.current = node;
    setContent(node);
  }, [ref]);
  useTipOffset(tip ? content : null);
  return /* @__PURE__ */ jsx(Portal, { container, children: /* @__PURE__ */ jsxs(
    Content2,
    {
      ref: attach,
      align,
      sideOffset,
      collisionPadding,
      className: cx("buyscout-popover__content", tip && "buyscout-popover__content--tip", className),
      ...props,
      children: [
        children,
        tip && /* @__PURE__ */ jsx(Arrow2, { asChild: true, width: TIP_WIDTH, height: 0, children: /* @__PURE__ */ jsx("span", { className: "buyscout-popover__tip-probe", "aria-hidden": true }) })
      ]
    }
  ) });
}
PopoverContent.displayName = "PopoverContent";
export {
  Popover,
  PopoverAnchor,
  PopoverClose,
  PopoverContent,
  PopoverTrigger
};
//# sourceMappingURL=Popover.mjs.map